'use client';

import { useState, useEffect } from 'react';
import { DesktopSearchBar } from './DesktopSearchBar';
import { MobileSearchBar } from './MobileSearchBar';
import { useSearchParams } from 'next/navigation';
import useCurrency from '@/hooks/useCurrency';

export function SearchBar({ isHero }: { isHero?: boolean }) {
  const [isMobile, setIsMobile] = useState(false);

  const searchParams = useSearchParams();
  const { setCurrency } = useCurrency();
  if (searchParams.get('currency') && searchParams.get('currency') !== 'EGP') {
    setCurrency(searchParams.get('currency') as string);
  }

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, [typeof window !== 'undefined' && window.innerWidth]);

  return (
    <div className="w-full mx-auto">
      {isMobile ? <MobileSearchBar isHero={isHero} /> : <DesktopSearchBar isHero={isHero} />}
    </div>
  );
}
